<template>
    <b-container fluid class="mh-100 h-100 pl-0 ">
        <b-row class="h-100 mh-100">
            <b-col cols="4" class="mh-100 h-100">
                <!-- Répertoire de gestion documentaire à saisir  -->
                <b-card class="border-bottom pt-0 h-100 mh-100" bg-variant="white" header-tag="header" header-class="bg-white border-bottom" body-class="p-0">
                    <template #header>
                        <b-form-group :label="$t('AvailableFolders')" label-class="font-weight-bold text-dark p-0" label-size="lg" class="m-0"/>
                    </template>
                    <!-- Zone de saisie avec outils de recherches -->
                    <b-container fluid class="d-flex flex-column mh-100 h-100 p-3">
                        <b-row>
                            <b-col> {{ $t('SelectFolderForUser') }} </b-col>
                        </b-row>

                        <!-- Outils de recherches -->
                        <b-row>
                            <b-col cols="auto" class="mr-auto">
                                <!-- bouton de recherche de patrimoine -->
                                <b-button-group>
                                    <!-- HeritageSearch -> Recherche patrimoine -->
                                    <b-button @click="searchVisible = true" :pressed="searchVisible" v-b-tooltip.noninteractive.hover :title="$t('HeritageSearch')"  variant="outline-dark"
                                        :disabled="!$store.getters['CheckAction']('Read', undefined, Action)"
                                        class="btn-circle border-0 p-0">
                                        <b-icon icon="search" />
                                    </b-button>
                                </b-button-group>
                                <GenericTreeSearch :Variant="Variant" :UseGrouping="true" :Visible.sync="searchVisible" :title="$t('SearchTitle')" :RenderTree="RenderTree" @NodeSelectedEvent="onSearch($event)"/>
                            </b-col>
                            <b-col cols="auto">
                                <b-button-group>
                                    <!-- $t('CollapseAll') / Replier tout   $t('ExpandSelected') /-->
                                    <b-button @click="collapseExpandFolderTree(RenderTree)" v-b-tooltip.hover :title="IsExpandSelected? $t('CollapseAll') : $t('ExpandSelected')" variant="outline-dark"
                                        :disabled="!$store.getters['CheckAction']('Read', undefined, Action)"
                                        class="btn-circle mr-2 ml-1 my-1 border-0">
                                        <b-icon :icon="IsExpandSelected ? 'arrows-collapse' : 'arrows-expand'" />
                                    </b-button>
                                </b-button-group>
                            </b-col>
                        </b-row>

                        <!-- Arborescence de gestion documentaire -->
                        <b-row class="flex-grow-1 h-100 mh-100 overflow-auto ">
                            <b-col>
                                <GenericTreeView :Root="RenderTree" :SelectMode="selectModeEnum.MultiSimple" :UseBootstrapIcon="true" v-on="$listeners" @UnselectedEvent="onUnselectedFolder($event)" @SelectedEvent="onSelectedFolder($event)"/>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-card>
            </b-col>
            <b-col cols="8" class="pr-0">
                <!-- Répertoires associés -->
                <b-card class="border-bottom pt-0 h-100 mh-100" no-body bg-variant="white" header-class="bg-white border-bottom" footer-class="bg-white border-top">
                    <template #header>
                        <b-form-group :label="$t('SharedFolder')" label-class="font-weight-bold text-dark p-0" label-size="lg" class="m-0" />
                    </template>

                    <!-- Listes des répertoires selectionnés et pins de filtres -->
                    <b-container fluid class="d-flex flex-column mh-100 p-2 px-3" style="height: 85%;"> <!-- TODO: voir avec Fabien -->
                        <!-- Liste des répertoires -->
                        <b-row class="flex-grow-1 h-100 mh-100 overflow-auto ">
                            <b-col>
                                <!-- Répertoires selectionnés -->
                                <b-list-group-item v-for="folder in RenderTree.SelectedNodes" :key="$id(folder.Id)"
                                    class="rounded-pill my-2 py-1 pr-1 border d-flex justify-content-between align-items-center" :class="['text-'+Variant, 'border-'+Variant]" >
                                    <div>
                                        <b-icon icon="folder-symlink-fill" class="py-0 mx-2" />
                                        <span class="font-weight-semibold"> {{folder.Name}}</span>
                                    </div>
                                    <!-- Bouton pour supprimer le répertoire -->
                                    <b-button @click="unselectFolder(folder)" v-b-tooltip.noninteractive.hover :title="$t('Delete')"  :variant="'outline-' + Variant" 
                                        :disabled="!$store.getters['CheckAction']('Delete', undefined, Action)"
                                        class="btn-circle border-0 p-0 mx-1">
                                        <b-icon icon="x" />
                                    </b-button>
                                </b-list-group-item>
                            </b-col>
                        </b-row>
                    </b-container>
                    
                    <!-- Pied de bloc gestion documentaire associé -->
                    <template #footer>
                        <b-container>
                            <b-row>
                                <b-col cols="auto" class="mr-auto px-0">{{ $tc('CountSelectedFolder', (RenderTree.SelectedNodes) ? RenderTree.SelectedNodes.length : 0, { count: (RenderTree.SelectedNodes) ? RenderTree.SelectedNodes.length : 0}) }}</b-col>
                                <b-col v-if="IsModified" cols="auto" class="px-0">{{ $t('WarnUpdatedFields') }}</b-col>
                            </b-row>
                        </b-container>
                    </template>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script lang="ts">

/** Composant vue.js et décorateur */
import Component from 'vue-class-component';
import { InjectReactive, Prop, PropSync } from 'vue-property-decorator';

/** Mode de selection supporté */
import SelectModeEnum from '@/enums/SelectModeEnum';

/** Fichiers de traductions */
import locales from "./locales/UserFolderSelector.json";

/** Composants 'TreeView' Génériques */
import GenericTreeSearch from '@/components/commons/Generics/GenericTree/GenericTreeSearch.vue';
import GenericTreeView from '@/components/commons/Generics/GenericTreeView.vue';
import GenericTreeUtils from '@/components/commons/Generics/GenericTree/GenericTreeUtils';
import { GenericTree, GenericTreeNode } from '@/components/commons/Generics/GenericTree/GenericTreeClass';

/** Sélecteur de répertoire documentaire permettant d’assigner des droits d’accès spécifiques aux éléments de gestion documentaire. */
@Component({
    components:{
        GenericTreeView,
        GenericTreeSearch
    },
    i18n: { messages : locales}
})
export default class UserFolderSelector extends GenericTreeUtils{
    /** Nécessaire pour pouvoir utiliser cet enum dans la section template */
    private selectModeEnum = SelectModeEnum;
    
    /** Variant du menu */
    @InjectReactive()
    private Variant!: string;

    /** Indique si les champs sont considéré comme modifié. */
    @Prop({default: false})
    public IsModified!: Boolean;

    /** Droit disponible pour l'utilisateur en cours */
    @InjectReactive()
    public Action!: string;

    /** Identifiant des dossiers partagés assignés */
    @PropSync("IdFolders",{ default : () => [] })
    public idFolders!: string[];

    /** Arbre à afficher */
    @Prop()
    public RenderTree!: GenericTree;

    /** Est-ce que la selection de est ouverte */
    private visibleSelector: boolean = false;

    /** Est-ce que la recherche est ouverte */
    private searchVisible: boolean = false;

    /** 
     * Exécuter lors de la sélection d'un nœud dans le menu de recherche.
     * @param folder Répertoire résultant de la recherche.
     */
    private onSearch(folder: GenericTreeNode){
        if(!folder.Checked){
            this.selectNode(this.RenderTree, folder);
        }
    }

    /** 
     * Retire la selection du noeud 
     * @param folder Répertoire devant perdre la sélection
     */
    private unselectFolder(folder: GenericTreeNode){
        if(folder.Checked){
            this.unSelectNode(this.RenderTree, folder);
        }
    }
    
    /**
     * Traite la selection d'un répertoire
     * @param folder répertoire cible
     */
    private onSelectedFolder(folder: GenericTreeNode) {
        const index = this.idFolders.indexOf(folder.Id.toString());
        if(index < 0)
            this.idFolders.push(folder.Id.toString());
    }

    /**
     * Traite le retrait de la selection d'un répertoire
     * @param folder répertoire cible
     */
    private onUnselectedFolder(folder: GenericTreeNode) {
        const index = this.idFolders.indexOf(folder.Id.toString());
        if(index > -1)
            this.idFolders.splice(index, 1);
    }

    /** Initialise le selecteur */
    async created(){
        this.initSelection(this.RenderTree, this.idFolders);
        /** Ouvre le sélecteur */
        this.visibleSelector = ! this.visibleSelector;
        this.collapseExpandFolderTree(this.RenderTree);
        
        this.$emit('loaded');
    }
}

</script>

<style scoped>
</style>